import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = ["modal"]

  connect() {
    if (this.element.dataset.openMethodOverride === 'show') {
      this.modalTarget.show()
    } else {
      this.modalTarget.showModal()
    }
  }

  submitEnd(e) {
    if (e.detail.success) {
      this.modalTarget.close()
    }
  }

  onModalClose() {
    const iframes = this.modalTarget.querySelectorAll("iframe")
    iframes.forEach((iframe) => {
      iframe.src = iframe.src
    })
  }
}
